import React, { FunctionComponent } from 'react';
import styled from '@emotion/styled';
import ReactHtmlParser from 'react-html-parser';
import { JobDetailDescriptionProps } from '../../types/jobsTypes';

const JobDescriptionBox = styled.div`
  text-align: left;
  font-size: 1rem;
  p {
    font-size: 1rem;
    line-height: 1.5;
    margin: 1.25rem 0;
  }
  ul {
    margin-left: 1.15rem;
  }
`;

const JobDetailDescription: FunctionComponent<JobDetailDescriptionProps> = ({
  description,
}) => <JobDescriptionBox>{ReactHtmlParser(description)}</JobDescriptionBox>;

export default JobDetailDescription;
